import type { SourceDefinition } from '../types';

export const config = {
  id: 'pulse',
  kind: 'static',
} satisfies SourceDefinition;
